export const READ_ONLY = 'readOnly';
export const PREVIEW = 'preview';
export const EDIT = 'edit';
